import { render, staticRenderFns } from "./AttendenceCard.vue?vue&type=template&id=b25e3fca"
import script from "./AttendenceCard.vue?vue&type=script&lang=js"
export * from "./AttendenceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports